import { c as _c } from "react/compiler-runtime";
import { Box, VStack } from '@chakra-ui/react';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import ContentIntro from '@src/components/sco/Education/Other/ContentIntro';
import { VideoHero } from '@src/components/sco/Education/VideoLanding/VideoHero';
import { VideoList } from '@src/components/sco/Education/VideoLanding/VideoList';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { useWindow } from '@src/hooks/useWindow';
import React, { useState } from 'react';
export const VideoSearch = () => {
  const $ = _c(30);
  const educationContext = useEducationContext();
  const window = useWindow();
  const [showHero, setShowHero] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = hasResults => {
      setShowHero(hasResults);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const handleVideoListResults = t0;
  let t1;
  if ($[1] !== educationContext || $[2] !== window?.location?.href) {
    t1 = () => {
      educationContext.setBreadcrumbs([{
        title: "Videos",
        href: "/videos"
      }, {
        title: `${[...educationContext.activeTerms.map(_temp), educationContext.activeKeywords && `"${educationContext.activeKeywords}"`].filter(Boolean).join(" + ")}`,
        href: window?.location?.href
      }]);
    };
    $[1] = educationContext;
    $[2] = window?.location?.href;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== educationContext.activeKeywords || $[5] !== educationContext.activeTerms) {
    t2 = [educationContext.activeKeywords, educationContext.activeTerms];
    $[4] = educationContext.activeKeywords;
    $[5] = educationContext.activeTerms;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useUniversalEffect(t1, t2);
  let t3;
  if ($[7] !== educationContext.activeKeywords || $[8] !== educationContext.activeTerms || $[9] !== showHero) {
    t3 = showHero && <Box width="full"><VideoHero keywords={educationContext.activeKeywords} termSlugs={educationContext.activeTerms.map(_temp2)} /></Box>;
    $[7] = educationContext.activeKeywords;
    $[8] = educationContext.activeTerms;
    $[9] = showHero;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== educationContext.activeTerms) {
    t4 = educationContext.activeTerms.map(_temp3).join(" + ");
    $[11] = educationContext.activeTerms;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = educationContext.activeKeywords && educationContext.activeTerms.length > 0 && "+";
  let t6;
  if ($[13] !== educationContext.activeKeywords) {
    t6 = <Box as="span" textTransform="capitalize">{educationContext.activeKeywords}</Box>;
    $[13] = educationContext.activeKeywords;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <ContentIntro description="Learn the best practices of entrepreneurship from world-class experts." title={<>{t4}{" "}{t5}{" "}{t6}{" "}Video Classes</>} />;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = educationContext.activeKeywords;
  let t9;
  if ($[19] !== educationContext.activeTerms) {
    t9 = educationContext.activeTerms.map(_temp4);
    $[19] = educationContext.activeTerms;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== educationContext.activeKeywords || $[22] !== t9) {
    t10 = <VideoList keywords={t8} termSlugs={t9} onResults={handleVideoListResults} />;
    $[21] = educationContext.activeKeywords;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t7) {
    t11 = <VStack align="flex-start" gap={20} padding={10} width="full">{t7}{t10}</VStack>;
    $[24] = t10;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t3) {
    t12 = <VStack align="center" justify="stretch" width="full">{t3}{t11}</VStack>;
    $[27] = t11;
    $[28] = t3;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
};
function _temp(t) {
  return t.name;
}
function _temp2(t_0) {
  return t_0.slug;
}
function _temp3(t_1) {
  return t_1.name;
}
function _temp4(t_2) {
  return t_2.slug;
}